import { SET_FILTERED, SET_FILTERED_ON_ROUTE_CHANGE } from "./constants";
import initialState from "./initialState";
function sortFilters(a, b) {
	let item1 = a;
	let item2 = b;
	if (a.key) {
		item1 = a.key;
		item2 = b.key;
	}
	if (item1 === "ST" || item2 === "ST" || item1 === "st" || item2 === "st") {
		return -1;
	}
	if (item1 < item2) {
		return -1;
	}
	if (item1 > item2) {
		return 1;
	}
	return 0;
}
export default (state = initialState, action) => {
	switch (action.type) {
		case SET_FILTERED_ON_ROUTE_CHANGE:
			return {
				...initialState
			};
		case SET_FILTERED:
			const { filters, pois } = action;
			const dataKeys = Object.keys(pois);
			let count = 0;
			const ids = [];
			const check = lot => {
				const item = pois[lot];
				return (
					((typeof filters.floor === "string" &&
							(filters.floor === item.floor || filters.floor === "all")) ||
						filters.floor.indexOf("all") > -1 ||
						filters.floor.indexOf(item.floor) > -1) &&
					//  || filters.floor.length === 0
					Number(filters.surface[0]) <= Number(item.surface) &&
					Number(filters.surface[1]) >= Number(item.surface) &&
					// @TODO This is need to be fixed
					// filters.price[0] >= 0 &&
					// (Number(filters.price[0]) <= Number(item.price) &&
					// 	Number(filters.price[1]) >= Number(item.price)) &&
					(filters.benefits.length === 0 ||
						filters.benefits.filter(benefit => Boolean(item[benefit]))
							.length === filters.benefits.length) &&
					filters.type.indexOf(item.type) > -1 &&
					["indisponible", "resa", "VENDU", "no"].indexOf(item.visible) === -1
				);
			};
			const data = {};
			dataKeys.forEach(lot => {
				if (check(lot)) {
					ids.push(lot);
					count += 1;
					if (!data[pois[lot].type]) {
						data[pois[lot].type] = [];
					}
					data[pois[lot].type].push(pois[lot]);
				}
			});
			return {
				...state,
				[action.building]: {
					...state[action.building],
					data: Object.keys(data)
						.sort(sortFilters)
						.reduce((items, type) => {
							items[type] = data[type];

							return items;
						}, {}),
					count,
					ids
				}
			};

		default:
			return state;
	}
};
